import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=0789c3f4&"
import script from "./Details.vue?vue&type=script&lang=js&"
export * from "./Details.vue?vue&type=script&lang=js&"
import style0 from "./Details.vue?vue&type=style&index=0&id=0789c3f4&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0789c3f4')) {
      api.createRecord('0789c3f4', component.options)
    } else {
      api.reload('0789c3f4', component.options)
    }
    module.hot.accept("./Details.vue?vue&type=template&id=0789c3f4&", function () {
      api.rerender('0789c3f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/service/Details.vue"
export default component.exports